import EventEmitter from 'eventemitter3';
import TypedEmitter from 'typed-emitter';

import { Events } from './types';

export const emitter = new EventEmitter() as TypedEmitter<Events>;
